import React, { Component, Fragment } from 'react';
import agent from '../../../agent'
import ACTS from '../../../constants'
import { native, appData, getParameters } from '../../../utils/common'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const mapStateToProps = state => ({ ...state.consulting });

const mapDispatchToProps = dispatch => ({
    getMemberInfo: () =>
        dispatch({ type: ACTS.GET_MEMBER_INFO, payload: agent.Consulting.getMemberInfo() }),
    insertConsulting: (param) =>
        dispatch({ type: ACTS.INSERT_CONSULTING, payload: agent.Consulting.insertConsulting(param) })
});

const $ = window.$;

class Consulting extends Component {
    constructor() {
        super();

        this.state = {
            companyNm : '',
            upjong : '',
            name : '',
            hp : '',
            email : ''
        }
        //this.isApp = agent.getSessionInfo().isApp;

        //제휴사코드
        this.ac = window.sessionStorage.getItem('ac');
        if(!this.ac){
            this.ac = getParameters('ac');
            if(this.ac){
                window.sessionStorage.setItem('ac', this.ac);
            }
        }
       
    }; 

    componentDidMount(){  
       this.props.getMemberInfo();
    }

    dateList = () => {
        let dates = [];
        for(var i = 10; i <= 17; i++){
            if(i != 12){
                dates.push({
                    value:i+':00',
                    date: (i > 12 ? "오후 " : "오전 ") + ( i > 12 ? i-12 : i ) + ':00'
                })
                dates.push({
                    value:i+':30',
                    date: (i > 12 ? "오후 " : "오전 ") + ( i > 12 ? i-12 : i ) + ':30'
                })
            }
        }
        return dates;
    }

    

    saveConsulting = () => {
        //let companyNm = '', upjong = '', name ='', hp = '', email = '';
        //let question = '', counselDt = '', counselTime = '';
        let kind = 'QNA11', kindNm = '';
        let question = $('textarea[name=question]').val();
        let counselDt = $('input[name=counselDt]').val();

        if(question === ""){
            alert('문의내용을 입력해주세요.')
            return false;
        }

        if(counselDt === ""){
            alert('상담가능 일자를 입력해주세요.')
            return false;
        }

        if($('input[name=companyNm]').val() === ""){
            alert('사업장명을 입력해주세요.')
            return false;
        }

        if($('input[name=hp]').val() === ""){
            alert('연락처를 입력해주세요.')
            return false;
        }

        let param = {
            companyNm : $('input[name=companyNm]').val(), 
            upjong : $('input[name=upjong]').val(), name : $('input[name=name]').val(), 
            hp : $('input[name=hp]').val(), email : $('input[name=email]').val(),
            question : question, 
            counselDt : counselDt, counselTime : $('input[name=counselTime]').val(), 
            kind : kind, kindNm : kindNm
        }

        this.props.insertConsulting(param)

    }

    onClickBack = () => {
        window.history.back();        
    }
   
    render(){   
        
        let dates = this.dateList();

        const { info } = this.props; 
        
        if(info != undefined){
            this.state.companyNm = info.cName;
            this.state.upjong = info.jongmok;
            this.state.name = info.ceoName;
            this.state.hp = info.hp;
            this.state.email = info.email;
        }
        

        return ( 
            <Fragment>
                <div className="header">
                    <span className="top_btn pc" onClick={ this.onClickBack }><i className="fas fa-arrow-left fa-lg" style={{ color:"#000" }}></i></span>
                    <h1>상담하기</h1>
                </div>         
                {   
                    <div className="container">
                        <div className="writeForm__Wrap">
                            <div className="" style={{ padding:'13px' }}>
                                <table border="0" summary="" className="writeTb">
                                    <caption></caption>
                                    <colgroup>
                                        <col/>
                                    </colgroup>
                                    <tbody>                                
                                        <tr>
                                            <td>
                                                <input name="companyNm" className="w98p ipTxt vm" type="text" ref="companyNm" value={ this.state.companyNm } placeholder="(필수) 사업장명을 입력하세요."/>
                                                <input name="email" type="hidden" value={ this.state.email }/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input name="upjong" className="w98p ipTxt vm" type="text" ref="upjong" value={ this.state.upjong } placeholder="업종을 입력하세요."/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input name="name" className="w98p ipTxt vm" type="text" ref="name" value={ this.state.name } placeholder="담당자명을 입력하세요."/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input name="hp" className="w98p ipTxt vm" type="text" ref="hp" value={ this.state.hp } placeholder="(필수) 연락처를 입력하세요. - 포함"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>   
                                                <br/><span>(필수) 상담가능 시간 </span><br/><br/>
                                                <input type="date" className="w20p ipTxt vm" name="counselDt" fieldname="일자"/>
                                                <select name="counselTime" fieldname="시간">
                                                    {
                                                        dates.map(it => {
                                                            return (
                                                                <Fragment>
                                                                    <option value={ it.value }>{ it.date }</option>
                                                                </Fragment>
                                                            )
                                                        })
                                                    }                                               
                                                </select>
                                                
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <textarea name="question" className="w98p  vm" style={{ height:'250px' }}></textarea>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <a href="#" onClick={ e => this.saveConsulting() } className="btnBlockFlat">문의하기</a>
                            </div>
                        </div>
                    </div>                
                }
            </Fragment>
                               
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Consulting);


// WEBPACK FOOTER //
// ./src/components/pages/consulting/index.js